import { PRESET_TONE_OF_VOICE } from 'src/data/toneOfVoice';

import {
  AdvisorIcon,
  EducatorIcon,
  EmpatheticIcon,
  EngagingIcon,
  EntertainerIcon,
  InnovatorIcon,
  MotivatorIcon,
  TrendsetterIcon,
} from './assets';

export const getIcon = (presetTov) => {
  switch (presetTov) {
    case PRESET_TONE_OF_VOICE.engaging:
      return EngagingIcon;
    case PRESET_TONE_OF_VOICE.innovator:
      return InnovatorIcon;
    case PRESET_TONE_OF_VOICE.trendsetter:
      return TrendsetterIcon;
    case PRESET_TONE_OF_VOICE.advisor:
      return AdvisorIcon;
    case PRESET_TONE_OF_VOICE.motivator:
      return MotivatorIcon;
    case PRESET_TONE_OF_VOICE.entertainer:
      return EntertainerIcon;
    case PRESET_TONE_OF_VOICE.empathetic:
      return EmpatheticIcon;
    case PRESET_TONE_OF_VOICE.educator:
      return EducatorIcon;

    default:
      return null;
  }
};
